import { Switch as ChakraSwitch, FormControl, FormLabel, HStack } from "@chakra-ui/react"

export default function Switch({ label, colorScheme = 'orange', ...props }){
    return(
    <FormControl>
        <HStack alignItems="center">
            <ChakraSwitch colorScheme={colorScheme} {...props} />
            { label && <FormLabel children={label} />}
        </HStack>
    </FormControl>
    )
}